import { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../requestMethods";
import {
  getWishListData,
  moveToCart,
} from "../apiCalls/wishlist";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const ProductColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

const ProductSize = styled.span``;

const Wishlist = () => {
  // const cart = useSelector((state) => state.cart.products);
  const wishlist = useSelector((state) => state.wishlist.products);
  const user = useSelector((state) => state.user.currentUser);
  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getWishListData(dispatch, user?._id);
    console.log("running from there");
  }, [dispatch]);

  const handleMoveToCart = (product) => {
    moveToCart(dispatch, user._id, product)
  }

  return (
    <>
      {" "}
      <Breadcrumb activeName={"Wishlist"} middleName={""} middleUrl={""} />
      <section className="cart-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="cart-content">
                <div className="cart-data">
                  <h3 className="cart-page-title title mb-1">
                    Wishlist items ({wishlist[0]?.listItems?.length})
                  </h3>
                  <div className="table-data">
                    <table className="cart-table">
                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wishlist[0]?.listItems?.map((product, index) => (
                          <tr key={index}>
                            <td className="cart-image">
                              <Link to={`/product/${product?.productId?._id}`}>
                                <img
                                  src={
                                    `${ImageUrl}` +
                                    product?.productId?.mainImg[0]?.filename
                                  }
                                  width="120"
                                  height="120"
                                />
                              </Link>
                            </td>
                            <td className="cart-title">
                              <Link to={`/product/${product._id}`}>
                                <span className="cart-product-title">
                                  {product?.productId?.title}
                                </span>
                              </Link>
                              <div className="product-cart-color">
                                <span>Color: </span>
                                <ProductColor color={product.color} />
                              </div>
                              <ProductSize>
                                <span className="cart-size">Size:</span>{" "}
                                {product.size}
                              </ProductSize>
                            </td>
                            <td className="cart-qty">
                              <span>{product?.quantity}</span>
                            </td>
                            <td className="cart-total">
                              <span>
                                {" "}
                                ₹{" "}
                                {product?.productId?.price * product?.quantity}
                              </span>
                            </td>
                            <td className="cart-action">
                              {/* <FaTimes
                                className="close-icon"
                                  onClick={() =>
                                    handleRemoveFromCart(product._id)
                                  }
                              /> */}
                              <button className="btn move-cart" onClick={() => handleMoveToCart(product)}>
                                Move to Cart
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="cart-more-action">
                    <Link to="/products" className="btn">
                      continue shopping
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wishlist;
